import React from "react";
import { stackList } from "../../data/ProjectData";
import {
  Image,
  Technologies,
  Tech,
  TechImg,
  TechName,
  ContactWrapper,
} from "./AboutElements";
function About() {
  return (
    <ContactWrapper id="about">
      <div className="Container">
        <div className="SectionTitle">About Me</div>
        <div className="BigCard">
          {/*<Image
            src="https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/man-svgrepo-com.svg"
            alt="man-svgrepo"
          />*/}
          <div className="AboutBio">
            Hello! My name is <strong>Abdulmajeed Alduaifi</strong> I holds a
            Bachelor's degree in Software Engineering, interested in website
            development.  I have the skills to cooperate with the team, quickly
            learn and solve difficult problems in the fastest time, loving what
            is new in the world of technology.
          </div>
          <div className="AboutBio tagline2">
            I have become confident using the following technologies:
          </div>
          <Technologies>
            {stackList.map((stack, index) => (
              <Tech key={index} className="tech">
                <TechImg src={stack.img} alt={stack.name} />
                <TechName>{stack.name}</TechName>
              </Tech>
            ))}
          </Technologies>
        </div>
      </div>
    </ContactWrapper>
  );
}

export default About;
